// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2ickm","tab":"ProcedureTabs_tab__dhxDI"};